const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export const toSplitAmount = (value) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? roundMoney(parsed) : 0;
};

export const createSplitPaymentLine = (amount = '') => ({
  id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
  paymentMethod: '',
  amount: amount === '' || amount == null ? '' : String(amount),
});

export const createDefaultSplitPaymentLines = (amountDue) => {
  const due = Math.max(0, toSplitAmount(amountDue));
  return [createSplitPaymentLine(due > 0 ? due.toFixed(2) : '')];
};

export const sumSplitPaymentLines = (lines) => roundMoney(
  (lines || []).reduce((total, line) => total + toSplitAmount(line.amount), 0),
);

export const validateSplitPaymentLines = ({
  lines,
  amountDue,
  allowDiscount = true,
  minimumCollected = 0,
}) => {
  const due = Math.max(0, toSplitAmount(amountDue));
  const minCollected = Math.min(due, Math.max(0, toSplitAmount(minimumCollected)));
  const errors = {};
  const payments = [];
  const seenMethods = new Set();

  (lines || []).forEach((line, index) => {
    const amount = toSplitAmount(line.amount);
    const method = line.paymentMethod || '';

    if (amount <= 0) {
      if (method && !allowDiscount) {
        errors[`line-${index}-amount`] = 'appointmentCheckout.errors.amountRequired';
      }
      return;
    }

    if (!method) {
      errors[`line-${index}-method`] = 'appointmentCheckout.errors.paymentMethodRequired';
    }

    if (method && seenMethods.has(method)) {
      errors[`line-${index}-method`] = 'appointmentCheckout.errors.duplicateMethod';
    }

    if (method) {
      seenMethods.add(method);
    }

    if (method && !errors[`line-${index}-method`]) {
      payments.push({ paymentMethod: method, amount });
    }
  });

  const collected = roundMoney(payments.reduce((total, payment) => total + payment.amount, 0));

  if (collected > due) {
    errors.total = 'appointmentCheckout.errors.amountRange';
  } else if (!allowDiscount && due > 0 && collected !== due && Object.keys(errors).length === 0) {
    errors.total = payments.length === 0
      ? 'appointmentCheckout.errors.paymentMethodRequired'
      : 'appointmentCheckout.errors.fullAmountRequired';
  } else if (collected < minCollected) {
    errors.total = 'appointmentCheckout.errors.membershipCoverRequired';
  }

  return {
    errors,
    payments,
    collected,
    remaining: roundMoney(Math.max(0, due - collected)),
    isValid: Object.keys(errors).length === 0,
  };
};

export const toCheckoutPayload = ({ payments, collected, amountDue }) => ({
  payments,
  amountReceived: collected,
  paymentMethod: payments[0]?.paymentMethod ?? null,
  discount: roundMoney(Math.max(0, toSplitAmount(amountDue) - collected)),
});
